import './RowSelector.scss';
import classNames from 'classnames';
import Add from '@mui/icons-material/Add';

interface RowSelectorProps {
  active: boolean;
  disabled: boolean;
}

const RowSelector = ({ active, disabled }: RowSelectorProps) => {
  return (
    <button
      className={classNames({
        'row-selector': true,
        'row-selector-active': active,
        'row-selector-disabled': disabled
      })}
      disabled={disabled}
    >
      <Add
        sx={{ fontSize: '22px' }}
        className={classNames({
          'row-selector-icon': true,
          'row-selector-icon-active': active
        })}
      />
    </button>
  );
};

export default RowSelector;
